import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

const STORAGE_KEY = 'dashboard_auth';
const KEY_STORAGE = 'dashboard_key';

interface Props {
  children: React.ReactNode;
}

const DashboardPasswordGate = ({ children }: Props) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) === 'true' && localStorage.getItem(KEY_STORAGE)) {
      setAuthenticated(true);
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(false);
    try {
      const { data, error: fnError } = await supabase.functions.invoke('verify-dashboard', {
        body: { password },
      });
      if (fnError || !data?.valid) {
        setError(true);
      } else {
        localStorage.setItem(STORAGE_KEY, 'true');
        localStorage.setItem(KEY_STORAGE, password);
        setAuthenticated(true);
      }
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  if (authenticated) return <>{children}</>;

  return (
    <div className="min-h-screen bg-[#0a0e1a] flex items-center justify-center px-4">
      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-4 text-center">
        <div className="flex justify-center">
          <div className="h-14 w-14 rounded-full bg-white/10 flex items-center justify-center">
            <Lock className="h-6 w-6 text-white/70" />
          </div>
        </div>
        <h1 className="text-xl font-semibold text-white">Dashboard</h1>
        <p className="text-sm text-white/50">Voer het wachtwoord in om toegang te krijgen</p>
        <Input
          type="password"
          placeholder="Wachtwoord"
          value={password}
          onChange={(e) => { setPassword(e.target.value); setError(false); }}
          className="bg-white/10 border-white/20 text-white placeholder:text-white/40"
          autoFocus
        />
        {error && <p className="text-red-400 text-sm">Onjuist wachtwoord</p>}
        <Button type="submit" className="w-full" disabled={loading}>
          {loading ? 'Controleren...' : 'Inloggen'}
        </Button>
      </form>
    </div>
  );
};

export default DashboardPasswordGate;
